import React, { useState } from 'react';
import { ContactModal } from './ContactModal';
export function CTASection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-33" />
      <section className="py-24 bg-orange relative overflow-hidden" data-id="element-34">
        <div className="absolute inset-0 bg-noise opacity-20" data-id="element-35"></div>
        <div className="absolute top-0 left-0 w-full h-4 bg-navy" data-id="element-36"></div>
        <div className="absolute bottom-0 left-0 w-full h-4 bg-navy" data-id="element-37"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-38">
          <h2 className="text-4xl md:text-7xl text-white mb-8 drop-shadow-md" data-id="element-39">
            READY FOR REAL COMFORT?
          </h2>
          <p className="text-xl md:text-2xl text-orange-100 font-sub uppercase tracking-wide mb-12 max-w-3xl mx-auto" data-id="element-40">
            Honest pricing. Quality workmanship. The State 48 Guarantee.
          </p>

          <div className="bg-cream p-8 md:p-12 rounded-sm shadow-2xl max-w-3xl mx-auto transform rotate-1 border-4 border-navy" data-id="element-41">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8" data-id="element-42">
              <div className="text-center md:text-right" data-id="element-43">
                <p className="text-brown font-sub text-xl uppercase mb-1" data-id="element-44">
                  Call us today
                </p>
                {/* Mobile: direct call */}
                <a href="tel:6025842141" className="sm:hidden text-4xl md:text-5xl font-display text-navy hover:text-orange transition-colors block" data-id="element-45">
                  602-584-2141
                </a>
                {/* Desktop: open modal */}
                <button onClick={() => setIsModalOpen(true)} className="hidden sm:block text-4xl md:text-5xl font-display text-navy hover:text-orange transition-colors" data-id="element-46">
                  602-584-2141
                </button>
              </div>

              <div className="hidden md:block w-px h-24 bg-brown/20" data-id="element-47"></div>

              <div className="text-center md:text-left" data-id="element-48">
                <p className="text-brown font-sub text-xl uppercase mb-2" data-id="element-49">
                  Or schedule online
                </p>
                {/* Mobile: direct call */}
                <a href="tel:6025842141" className="sm:hidden block bg-navy text-white px-8 py-3 font-sub text-xl uppercase tracking-wide rounded-sm shadow-lg" data-id="element-50">
                  Book Appointment
                </a>
                {/* Desktop: open modal */}
                <button onClick={() => setIsModalOpen(true)} className="hidden sm:block bg-navy hover:bg-navy-700 text-white px-8 py-3 font-sub text-xl uppercase tracking-wide rounded-sm shadow-lg transition-all" data-id="element-51">
                  Book Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}